export const signupChallengeTypes = Object.freeze({
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD',
})

export const signupErrorCodes = Object.freeze({
  TEMPORARY_PASSWORD_EXPIRED: 'TEMPORARY_PASSWORD_EXPIRED',
})
